import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Button from '@mui/material/Button';
import {
  Edit as EditIcon,
  Trash2 as TrashIcon
} from 'react-feather';
import { useNavigate } from 'react-router-dom';
import DeleteModal from 'src/components/modal/DeleteModal';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
});

const UserListResults = ({
  users,
  exclude,
  paginate,
}) => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width: 768px)');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    text: 'Tem certeza que deseja excluir este Técnico ?',
  });

  const excludeUser = async (id) => {
    const confirm = await exclude(id);
    if (confirm) {
      setDeleteModal({
        ...deleteModal,
        open: false
      });
    }
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    paginate((newPage + 1));
  };

  const buttonEdit = (id) => {
    navigate(`/app/user/${id}`, { replace: true });
  };

  const deleteUser = (id) => {
    setDeleteModal({
      ...deleteModal,
      id,
      open: true,
      confirm: excludeUser,
      cancel: () => { }
    });
  };

  return (
    <>
      <Box sx={{ minWidth: 1050 }}>
        {isSmallScreen ? (
          <Grid
            container
            spacing={3}
          >
            {users.data.slice(0, limit).map((user) => (
              <Grid item xs={12} md={3} lg={3}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      alt={users.name}
                      sx={1}
                      image={user.image ? user.image : '/image/no-image.png'}
                      title={users.name}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {user.name}
                      </Typography>
                      <Typography gutterBottom variant="h5" component="h2">
                        {user.email}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      onClick={() => { buttonEdit(user.id); }}
                      title="Editar"
                      fullWidth
                      variant="contained"
                      color="primary"
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      onClick={() => { deleteUser(user.id); }}
                      title="Excluir"
                      fullWidth
                      variant="contained"
                      color="error"
                    >
                      <TrashIcon />
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Card>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>E-Mail</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.data.slice(0, limit).map((user) => (
                  <TableRow key={user.id}>
                    <TableCell>
                      <Avatar
                        sx={{ width: 80, height: 80 }}
                        alt={user.name}
                        src={user.image || '/image/no-image.png'}
                      />
                    </TableCell>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>
                      {user.email}
                    </TableCell>
                    <TableCell>
                      <Button onClick={() => buttonEdit(user.id)} variant="contained" color="primary">
                        <EditIcon />
                      </Button>
                      {!user.deleted && (
                      <Button onClick={() => deleteUser(user.id)} variant="contained" color="error">
                        <TrashIcon />
                      </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        )}
      </Box>
      <TablePagination
        component="div"
        count={users.meta.total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[]}
      />
      <DeleteModal modal={deleteModal} />
    </>
  );
};

UserListResults.propTypes = {
  users: PropTypes.array.isRequired,
  exclude: PropTypes.array.isRequired,
  paginate: PropTypes.array.isRequired
};

export default UserListResults;
